import { GUID, Param } from "app/brightserve/brightserve.module";

export class IncidentDetail {
    Id: GUID;
    Author: string;
    Created: Date;
    Text: string;
    Status: Param;

    constructor(init?: Partial<IncidentDetail>){
        Object.assign(this, init);

        if (init && init.Status) {
            this.Status = new Param(init.Status);
        } else {
            this.Status = null;
        };
    }

    static BlankIncidentDetail(init?: any) {
        var incidentDetail = new IncidentDetail(init);
        incidentDetail.Id = GUID.newGuid();
        incidentDetail.Status = new Param();
        return incidentDetail;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/incident-detail.ts